import axios from 'axios';
const ApiService = {
    hostUrl: process.env.VUE_APP_APIURL,
    setHeaders: function(token){
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    },
    init(){
        console.log(process.env.VUE_APP_APIURL);
    },
    getAction(type, file, path){
        let fullUrl = this.hostUrl+'action/'+type+'/'+file;
        if(path != null) fullUrl += '/'+path;
        return fullUrl;
    }
};

export default ApiService;
